import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/api.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: [],
    searchingItems: false,

    order: null,
    authOrder: null,
    gettingOrder: true,
    gettingAuthOrder: false,
    brokerLoggedIn: false,

    activeOrder: null
  },

  getters: {
    currentStep: state => {
      const order = state.order;

      if (!order || !order.ui_step) return 'home';
      if (order.ui_step === 1) return 'instruments';
      if (order.ui_step === 2) return 'questionnaire';
      if (order.ui_step === 3) return 'offers';
      if (order.ui_step === 4) return 'offers';
      if (order.ui_step === 5) return 'customer-full-info';
      if (order.ui_step === 6) return 'order';
    },

    isBrokerLoggedIn: state => {
      return state.brokerLoggedIn;
    }
  },

  mutations: {
    setItems(state, data) {
      state.items = data;
    },

    setActiveOrder(state, data) {
      state.activeOrder = data;
    },

    unsetActiveOrder(state) {
      state.activeOrder = null;
    },

    setOrder(state, data) {
      state.order = data;
    },
    setAuthOrder(state, data) {
      state.authOrder = data;
    },

    setSearchingItems(state, val) {
      state.searchingItems = val;
    },

    setGettingOrder(state, val) {
      state.gettingOrder = val;
    },

    setGettingAuthOrder(state, val) {
      state.gettingAuthOrder = val;
    },

    updateSurveryLocally(state, { instrumentId, questionId, answerId }) {
      state.order.order_items.forEach(instrument => {
        if (!instrument.survey) instrument.survey = {};
        if (instrument.id === instrumentId) {
          instrument.survey[questionId] = answerId;
        }
      });
    },

    resetOrder(state) {
      state.order = null;
      state.gettingOrder = false;
    },

    setBrokerLoggedIn(state, data) {
      state.brokerLoggedIn = data;
    }
  },
  actions: {
    async searchItems({ commit }, query) {
      commit('setSearchingItems', true);

      // let data = await fetch('/api/searchItems')
      //   .then(response => {
      //     if (response.ok) {
      //       return response.json();
      //     }
      //     throw new Error('HTTP error ' + response.status);
      //   })
      //   .catch(() => {
      //     data = null; // Just clear it and if it errors again when
      //     // you make the call later, handle it then
      //   });

      // console.log('debug firstLoad', data);

      const resp = await api.searchItems(query);
      commit('setItems', resp.data);
      commit('setSearchingItems', false);
    },

    async getAuthOrder({ commit }, refreshing = false) {
      if (!refreshing) commit('setGettingAuthOrder', true);
      try {
        var resp = await api.getAuthOrder();
      } catch (error) {
        if (error.response.status === 403) {
          console.log('User has no auth order in progress');
        } else {
          console.log('Error getting auth order', error);
        }

        commit('setGettingAuthOrder', false);

        return null;
      }

      const order = resp.data;

      commit('setGettingAuthOrder', false);
      commit('setAuthOrder', order);

      return order;
    },

    async getOrder({ commit }, refreshing = false) {
      // check for reseller info

      const url = new URL(location.href);
      const refCode = url.searchParams.get('ref');

      // clean the url
      url.searchParams.delete('ref');
      if (refCode) {
        window.history.replaceState({}, '', `${location.pathname}?${url.searchParams.toString()}`);
      }

      if (!refreshing) commit('setGettingOrder', true);

      try {
        var resp = await api.getOrder(refCode);
      } catch (error) {
        if (error.response.status === 403) {
          console.log('User has no order in progress');
        } else {
          console.log('Error getting order', error);
        }

        commit('setGettingOrder', false);

        return null;
      }

      const order = resp.data;
      commit('setGettingOrder', false);
      commit('setOrder', order);

      return order;
    }
  }
});
